import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';
import api from '../utils/api';
import { Calendar } from 'lucide-react';
import { getTimeSlots } from '../utils/helpers';

const RescheduleModal = ({ isOpen, onClose, appointment, onReschedule, user }) => {
  const [newDate, setNewDate] = useState(appointment?.scheduled_date || '');
  const [newTime, setNewTime] = useState(appointment?.scheduled_time || '');

  const handleReschedule = () => {
    if (!newDate) {
      toast.error('Please select a new date');
      return;
    }

    if (appointment?.service_type === 'time_based' && !newTime) {
      toast.error('Please select a new time');
      return;
    }

    // Pass data to parent
    onReschedule({
      appointmentId: appointment.id,
      scheduled_date: newDate,
      scheduled_time: appointment?.service_type === 'time_based' ? newTime : null
    });
  };

  if (!appointment) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Calendar className="w-5 h-5 text-purple-600" />
            Reschedule Appointment
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="p-4 bg-purple-50 rounded-lg">
            <p className="text-sm text-purple-800">
              <strong>Patient:</strong> {appointment.patient_name}
            </p>
            <p className="text-sm text-purple-800">
              <strong>Service:</strong> {appointment.service_name}
            </p>
            <p className="text-sm text-purple-600 mt-2">
              Current: {appointment.scheduled_date}
              {appointment.scheduled_time && ` at ${appointment.scheduled_time}`}
            </p>
          </div>

          <div>
            <Label htmlFor="newDate">New Date</Label>
            <Input
              id="newDate"
              data-testid="reschedule-date-input"
              type="date"
              value={newDate}
              onChange={(e) => setNewDate(e.target.value)}
              min={new Date().toISOString().split('T')[0]}
              className="mt-2"
            />
          </div>

          {appointment?.service_type === 'time_based' && (
            <div>
              <Label htmlFor="newTime">New Time</Label>
              <select
                id="newTime"
                data-testid="reschedule-time-select"
                value={newTime}
                onChange={(e) => setNewTime(e.target.value)}
                className="mt-2 flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
              >
                <option value="">Select a time</option>
                {getTimeSlots().map(time => (
                  <option key={time} value={time}>{time}</option>
                ))}
              </select>
            </div>
          )}

        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={handleReschedule}
            data-testid="reschedule-submit-button"
            className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700"
          >
            Reschedule
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RescheduleModal;
